import SteamLoginPage from '../steamLogin/SteamLoginPage';

export default function CryptomusLoginPage() {
    const nextPage = '/cryptomus/steam/amount';

    return <SteamLoginPage nextPage={nextPage} />;
}
